import { LayoutHOC } from 'base/ui/layout/layout';

import { ComplaintRoutes } from './routes';
import createEventReport from './THXLKN3Mien';
import createBCSoSanh3Mien from './SSXLKN3Mien';

export const createComplaintPage = (layoutHOC: LayoutHOC) => {
  const BCTongHop = createEventReport();
  const BCSoSanh = createBCSoSanh3Mien();
  const ComplaintPage = layoutHOC(ComplaintRoutes);

  return () => <ComplaintPage BCTongHop={BCTongHop} BCSoSanh={BCSoSanh} />;
};
